// Package imports:
import React from 'react';
// Component imports:
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import HafaSambandContactForm from '../ContactForms/HafaSambandContactForm/HafaSambandContactForm';

const HafaSamband: React.FC = () => {
    const { search } = window.location;
    const query = new URLSearchParams(search);
    const selectedTopicIndex = Number(query.get('selectedTopic'));

    return (
        <div className="KCL_hafa-samband">
            <div className="main__inner">
                <div className="shell">
                    <HeadSection
                        title="Hafa samband"
                    />
                    <div className="section__body">
                        <div className="section__body-inner">
                            <div className="section__content form form--signup">
                                <HafaSambandContactForm selectedTopic={selectedTopicIndex}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HafaSamband;
